import get from 'lodash.get';
import { createSelector } from 'reselect';
import { getPersonalDetails } from '../../ducks/selectors';

export const getIsUpdatingPassword = createSelector(getPersonalDetails, (personalDetails) => {
  const isUpdatingPassword = get(personalDetails, 'updatePassword.isLoading', false);

  return isUpdatingPassword;
});

export const getUpdatePasswordError = createSelector(getPersonalDetails, (personalDetails) => {
  const updatePasswordError = get(personalDetails, 'updatePassword.error', {});

  return updatePasswordError;
});
